export default __webpack_public_path__ + "static/nahrep-white-ae6dc3ac7568eb2dc555f98b642997a7.svg";